import Component from '../core/Component.js'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import { enableScrolling, disableScrolling } from '../services/Viewport/scroll'

export const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
}

export default class MobileNavigation extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            pages: []
        }

        this.enquireHandler = {
            match: () => this.close()
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
        enquire.register(queries.mediumUp, this.enquireHandler)
    }

    destroy() {
        document.documentElement.classList.remove('menu-is-open')
        document.removeEventListener('keydown', this.handleKeydown)
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    handleSwupLinkClick = () => {
        this.close()
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleClick = event => {
        const element = event.target.closest('button')
        if (element) {
            const pageEl = this.ref.pages.find(pageEl => pageEl.id === element.dataset.setPageId)
            if (pageEl) {
                this.openPage(pageEl.id)
            }
        }

        if (event.target.closest('a')) {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.documentElement.classList.add('menu-is-open')
        document.addEventListener('keydown', this.handleKeydown)
        disableScrolling()
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        document.documentElement.classList.remove('menu-is-open')
        document.removeEventListener('keydown', this.handleKeydown)
        enableScrolling()
    }

    openPage(pageId) {
        if (!pageId) {
            return
        }

        const pageEl = this.ref.pages.find(pageEl => pageEl.id === pageId)
        if (!pageEl) {
            return
        }

        this.ref.pages.forEach(page => this.closePage(page.id))
        pageEl.classList.add('is-visible')
        pageEl.offsetHeight
        pageEl.classList.add('is-active')
    }

    closePage(pageId) {
        if (!pageId) {
            return
        }

        const pageEl = this.ref.pages.find(page => page.id === pageId)
        if (!pageEl || !pageEl.classList.contains('is-active')) {
            return
        }

        pageEl.classList.remove('is-active')
        pageEl.offsetHeight
        pageEl.classList.remove('is-visible')
    }



}